<template>
  <b-card class="rounded-lg">
    <report-header
      :title="$t('ledger_close_status_title')"
      :scope-label="scopeLabel"
      :can-company="false"
      :company="false"
      @print="printReport"
    />
    <b-form-select
      v-model.number="year"
      :options="yearOptions"
      class="mb-1 ledger-year-select"
      @change="load"
    />
    <div
      v-if="loading"
      class="text-center py-3"
    >
      <b-spinner />
    </div>
    <div
      v-else-if="report"
      class="ledger-close-grid"
    >
      <button
        v-for="month in report.months || []"
        :key="month.month"
        type="button"
        class="ledger-close-cell"
        :class="cellClass(month)"
        @click="openMonth(month)"
      >
        <strong>{{ month.month }}</strong>
        <small>{{ label(month) }}</small>
        <small v-if="month.status === 'open' && month.ended && month.blocking_missing != null">{{ month.blocking_missing }}</small>
      </button>
    </div>
  </b-card>
</template>

<script>
import { BCard, BFormSelect, BSpinner } from 'bootstrap-vue'
import ReportHeader from './ReportHeader.vue'
import reportMixin from './reportMixin'
import { getCloseStatus } from '@/api/accounting/financialReports'
import { oneFrom } from '@/utils/ledger'

export default {
  name: 'CloseStatus',
  components: { BCard, BFormSelect, BSpinner, ReportHeader },
  mixins: [reportMixin],
  data() {
    return {
      year: new Date().getFullYear(),
      report: null,
      loading: false,
    }
  },
  computed: {
    yearOptions() {
      const current = new Date().getFullYear()
      const years = []
      for (let value = current + 1; value >= current - 6; value -= 1) years.push(value)
      return years
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    cellClass(month) {
      if (month.close_forced) return 'is-forced'
      if (month.status === 'closed') return 'is-closed'
      if (month.status === 'open' && month.ended) return 'is-open'
      return 'is-idle'
    },
    label(month) {
      if (month.close_forced) return this.$t('ledger_close_forced')
      if (month.status === 'closed') return this.$t('ledger_close_closed')
      if (month.status === 'open' && month.ended) return this.$t('ledger_close_open')
      return this.$t('ledger_close_not_created')
    },
    openMonth(month) {
      if (!month.period_id) {
        this.$router.push({ name: 'ledger-periods', query: { year: this.year } })
        return
      }
      this.$router.push({ name: 'ledger-periods-view', params: { id: month.period_id } })
    },
    async load() {
      this.loading = true
      try {
        const res = await getCloseStatus({ year: this.year })
        this.report = oneFrom(res)
      } catch (error) {
        this.toastError(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.ledger-year-select { max-width: 10rem; }
.ledger-close-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.5rem; }
@media (min-width: 768px) { .ledger-close-grid { grid-template-columns: repeat(6, 1fr); } }
.ledger-close-cell {
  border: 0; border-radius: 0.75rem; padding: 0.75rem; text-align: center; color: #fff;
  display: flex; flex-direction: column; gap: 0.2rem;
}
.is-closed { background: #28a745; }
.is-forced { background: #ff9f43; color: #3b2a00; }
.is-open { background: #ea5455; }
.is-idle { background: #b9b9c3; }
</style>
